import type { ModulationUserContractsReportSchema } from '@libs/data-access/entities'

import { httpServices } from '../../../../apis'
import type { QueryFnParams } from '../../../../types'

export type FetchModulationUserContractsReportOptions = QueryFnParams<{
  pathParams: {
    modulation_user_contract_id: number
  }
}>

/**
 *
 */
export const fetchModulationUserContractsReport = async (
  opts: FetchModulationUserContractsReportOptions
) => {
  const response =
    await httpServices.core.get<ModulationUserContractsReportSchema>(
      `/modulation_user_contracts/${opts.pathParams.modulation_user_contract_id}/report`
    )
  return response.data
}
